import { RootState } from '../rootReducer';
import { IAccount, PermissionAccessTypes } from './account';

export enum PERMISSION {
  RecipientsCommunity = 'recipientsCommunity',
}

const getPermissionStatus = (permissionToEvaluate: PERMISSION) => (state: Pick<RootState, 'accounts' | 'auth'>): PermissionAccessTypes => {
  const {
    accounts: {
      list
    } = {},
    auth: {
      user
    } = {}
  } = state;
  const accountId = user?.accountId;
  const account = list?.accounts.find((account) => account.id === accountId);
  return account?.permissions?.find((permission) => permission.name === permissionToEvaluate)?.accessLevel || PermissionAccessTypes.Hidden;
};

const getSelectedAccount = (state:Pick<RootState, 'accounts'>):IAccount | null => {
  const {
    accounts: {
      selectedAccount: { account } = {}
    } = {}
  } = state;

  return account || null;
};

const selectAccountById = (accountId: string) => (state: Pick<RootState, 'accounts'>): IAccount | undefined => {
  const {
    accounts: {
      list
    } = {}
  } = state;
  return list?.accounts.find((account) => account.id === accountId);
};

const getRecipientsCommunityStatus = getPermissionStatus(PERMISSION.RecipientsCommunity);

export const selectors = {
  getRecipientsCommunityStatus,
  getSelectedAccount,
  selectAccountById
};
